import React from 'react';
import { EUI_THEMES } from '../../../../src/themes'; // @ts-ignore importing from a JS file

import { applyTheme } from '../../services';
var THEME_NAMES = EUI_THEMES.map(function (_ref) {
  var value = _ref.value;
  return value;
});
var defaultState = {
  theme: THEME_NAMES[0],
  changeTheme: function changeTheme(themeValue) {
    applyTheme(themeValue);
  }
};
export var ThemeContext = /*#__PURE__*/React.createContext(defaultState);
export class ThemeProvider extends React.Component {
  constructor(props) {
    super(props);
    let theme = localStorage.getItem('theme');
    if (!theme || !THEME_NAMES.includes(theme)) theme = defaultState.theme;
    applyTheme(theme);
    this.state = {
      theme
    };
  }

  changeTheme = themeValue => {
    this.setState({
      theme: themeValue
    }, () => {
      localStorage.setItem('theme', themeValue);
      applyTheme(themeValue);
    });
  };

  render() {
    const {
      children
    } = this.props;
    const {
      theme
    } = this.state;
    return <ThemeContext.Provider value={{
      theme,
      changeTheme: this.changeTheme
    }}>
        {children}
      </ThemeContext.Provider>;
  }

}